import { getMetricFromResidentialLevels as r } from "../index6.js";
import { getLevelGlazedFacadeArea as t } from "../level-metrics/index21.js";
const o = (e) => r(e, t);
export {
  o as getResidentialGlazedFacadeArea
};
//# sourceMappingURL=index47.js.map
